import $ from 'jquery';
import Handlebars from 'handlebars/dist/cjs/handlebars';

const $resources = $('.resources');
$resources.each((i, el) => {
  const $el = $(el);
  const $list = $el.find('.resources-list');
  const $loadMoreBtn = $el.find('.resources-more-btn');
  let { layout, absoluteImagePaths, apiRoot: API_ROOT } = $el.data();
  let pageIndex = 1;

  function renderResources(data, template, replace, totalRecords) {
    let formattedData = [];

    // If there are results
    if (data.length > 0) {
      // $(data).each((_, resource) => {
      formattedData = data.map(resource => {
        // Date: "Sep 11, 2018"
        // Description: ""
        // Image: "/media(c0a4168c-5597-4a29-9a80-01585793b776)"
        // ImageTitle: ""
        // Last: false
        // Link: ""
        // Misc: ""
        // PageId: "7bc48a4d-1108-4597-af4e-91c721d46571"
        // Pillar: "International Payments"
        // Tags: ""
        // Title: "Heads Up: The Market Is Shifting"
        // Type: "Case Studies"
        // Url: "/en-us/Resources/Case-Studies/Heads-Up-The-Market-Is-Shifting"
        // Video: ""

        const resourceData = { ...resource };
        let imgPath = '/Frontend/Images/suWUBS/placeholder.gif';

        if (resourceData.Image) {
          if (absoluteImagePaths) {
            imgPath = `${API_ROOT}/${resourceData.Image}`;
          } else {
            imgPath = resourceData.Image;
          }
        } else {
          imgPath = null;
        }

        resourceData.imgPath = imgPath;
        resourceData.layout = layout;
        return resourceData;
      });

      if (replace) {
        $list.html($.parseHTML(template(formattedData)));
      } else {
        $list.append($.parseHTML(template(formattedData)));
      }
      // If at the end of the results. We support here 2 cases - JSON with Last value or JSON with Total Records
      if (totalRecords >= 0 ? totalRecords / $resources.data('resources-size') <= pageIndex : data[data.length - 1].Last) {
        // Hide the load more button
        $el.addClass('has-all-results');
      }
    }

    $el.removeClass('is-loading');
  }

  function getResources(replace) {
    // get data attributes
    const {
      // these properties will not get copied to dataAttributes object
      industry: defaultIndustry,
      layout,
      resourcesApi,
      apiRoot,
      resourcesCulture: c,
      resourcesSize: s,
      absoluteImagePaths,
      // the rest of the properties
      ...dataAttributes
    } = $el.data();

    // add renamed properties
    dataAttributes.c = c;
    dataAttributes.s = s;

    let resTmpl = $('#resource-item-template');
    let requiredParams = (typeof (resTmpl.data('required')) === 'undefined') ? '' : resTmpl.data('required');
    let makeAPICall = true;
    // get form data
    const { ...formData } = $el.serializeArray()
      .reduce((acc, curr) => {
        acc[curr.name] = curr.value;
        if (requiredParams.length > 0) {
          //if param exists
          if ((requiredParams).indexOf(curr.name)!= -1) {
            //do check value
            if (curr.value.trim() === '') {
              makeAPICall = false;
            }
          }
        }
        return acc;
      }, {})

    // allow attribute level industry to be set
    formData.industry = defaultIndustry || formData.industry;

    let url = `${API_ROOT}${resourcesApi}?p=${pageIndex}`;

    // Reset everything
    $el.removeClass('is-loading has-error has-all-results has-no-results');

    if (replace) {
      pageIndex = 1;
    }

    // merge filters, and then add the filters to url
    const filters = { ...dataAttributes, ...formData };
    Object.keys(filters).forEach((fltr) => {
      if (filters[fltr] != null && filters[fltr] !== '' && filters[fltr] !== 'null') {
        url += `&${fltr}=${filters[fltr]}`;
      }
    });

    if (!makeAPICall) {
      $el.addClass('has-all-results');
    } else {
      $.ajax({
        method: 'GET',
        url,
        dataType: 'json',
        contentType: 'application/json'
      })
        .done(data => {
          let tmpl = $('#resource-item-template');
          let main = tmpl.data('main');
          let total = tmpl.data('total');
          let datamain = data[main] ? data[main] : '';
          
          if (typeof main === 'undefined' ? data.length > 0 : datamain.length > 0) {
            renderResources(
              typeof main === 'undefined' ? data : datamain,
              Handlebars.compile(tmpl.html()),
              replace,
              typeof total === 'undefined' ? -1 : data[total]
            );
          } else {
            $list.html('');
            $el.addClass('has-no-results');
            $el.addClass('has-all-results');
          }
        })
        .fail(data => {
          console.log('fail', data);
          $el.addClass('has-error');
        });
    }
  }

  function nextPage() {
    pageIndex += 1;
    getResources();
  }

  // Bind events
  // ------------------------------------------------------------------------ //

  // Bind event to any select change
  $(el).find('select').each((_, selectEle) => {
    $(selectEle).select2();
    $(selectEle).change(e => getResources(true));
  })

  $loadMoreBtn.on('click', e => {
    e.preventDefault();
    nextPage();
  });

  Handlebars.registerHelper("audioSrc", function (find, replace, options) {
      var attributes = [];
      Object.keys(options.hash).forEach(key => {
          var escapedKey = Handlebars.escapeExpression(key);
          var escapedValue = Handlebars.escapeExpression(options.hash[key]).replace(find, replace);
          attributes.push(escapedKey + '="' + escapedValue + '"');
      })
      var escapedOutput = "<source " + attributes.join(" ") + " />";
      return new Handlebars.SafeString(escapedOutput);
  }); 

  // Get the initial content
  // ------------------------------------------------------------------------ //
  getResources();
});
